export const environment = {
  local: false,
  staging: true,
  production: false
};
